import { useMemo } from "react";
import { WebSettings, SocialNetworksId } from "../interfaces";
import { useAccountSettings, useSocialCoachSession } from "../utils";

export const useSocialNetworks = (
  withIGStory: boolean = true,
  coachIdOverride: string | number | undefined = undefined
) => {
  const { coachId } = useSocialCoachSession();
  const { hasAccountSetting } = useAccountSettings(coachIdOverride || coachId);
  const displayTikTok = hasAccountSetting(WebSettings.TIKTOK);
  const hasReputationManagement = hasAccountSetting(WebSettings.REPUTATION_MANAGEMENT);

  const socialNetworks: SocialNetworksId[] = useMemo(() => {
    const baseSns: SocialNetworksId[] = ["FB", "LI", "IG"];

    if (withIGStory) {
      baseSns.push("IG_STORY");
    }

    baseSns.push("TW");

    if (displayTikTok) {
      baseSns.push("TT");
    }
    if (hasReputationManagement) {
      baseSns.push("GL");
      baseSns.push("ZL");
    }

    return baseSns;
  }, [displayTikTok, hasReputationManagement, withIGStory]);

  const postableSocialNetworks: SocialNetworksId[] = useMemo(() => {
    return socialNetworks.filter(sn => sn !== "GL" && sn !== "ZL");
  }, [socialNetworks]);

  return {
    socialNetworks,
    postableSocialNetworks,
    displayTikTok,
    displayGoogle: hasReputationManagement,
    displayZillow: hasReputationManagement,
  };
};
